import { getContext, setContext } from 'svelte';

export type SelectValue = string | number;

export interface OptionMeta {
	value: SelectValue;
	label: string;
	disabled: boolean;
	description?: string;
	group?: string;
}

export interface SelectRegistryContext {
	register: (meta: OptionMeta) => void;
	unregister: (value: SelectValue) => void;
}

export interface SelectInteractiveContext {
	multiple: boolean;
	idPrefix: string;
	isSelected: (value: SelectValue) => boolean;
	isHighlighted: (value: SelectValue) => boolean;
	select: (value: SelectValue) => void;
	setHighlighted: (value: SelectValue) => void;
}

const REGISTRY_KEY = Symbol('select-registry');
const INTERACTIVE_KEY = Symbol('select-interactive');
const GROUP_KEY = Symbol('select-group');

export function setSelectRegistryContext(ctx: SelectRegistryContext): void {
	setContext(REGISTRY_KEY, ctx);
}

export function getSelectRegistryContext(): SelectRegistryContext | undefined {
	return getContext(REGISTRY_KEY);
}

export function setSelectInteractiveContext(ctx: SelectInteractiveContext): void {
	setContext(INTERACTIVE_KEY, ctx);
}

export function getSelectInteractiveContext(): SelectInteractiveContext | undefined {
	return getContext(INTERACTIVE_KEY);
}

export function setSelectGroupContext(label: string): void {
	setContext(GROUP_KEY, label);
}

export function getSelectGroupContext(): string | undefined {
	return getContext(GROUP_KEY);
}
